// input styles should match those in components/gassan-ui/Form/styles.ts
// button styles should match those in components/gassan-ui/Button/elements.tsx
export const genericStyles = "gn5jgu7";

require("./GigyaScreenSet.styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./GigyaScreenSet.styles.ts");